<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <div class="tips">
          <el-page-header
            @back="goBack"
            :content="model.name || ''"
          ></el-page-header>
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a
          href="javascript:;"
          @click="
            query.pageIndex = 1;
            initData();
          "
          class="uc-btn blue"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab3 bg-white">
      <div class="table">
        <table>
          <tr>
            <th>序</th>
            <th class="left">名称</th>
            <th>类型</th>
            <th>修改日期</th>
          </tr>
          <tr v-if="list.total_count == 0">
            <td colspan="4">
              <div class="content-empty">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
            </td>
          </tr>

          <tr v-for="(item, index) in list.items" :key="index">
            <td>{{ index + 1 }}</td>
            <td class="left">
              <router-link
                :to="{
                  name:
                    item.tenant_type === 'Course'
                      ? 'CourseDetails'
                      : 'KnowledgeDetails',
                  params: { id: item.tenant_id },
                }"
              >
                {{ item.name }}
              </router-link>
            </td>
            <td>
              <i
                :class="
                  item.tenant_type === 'Course'
                    ? 'el-icon-reading'
                    : 'el-icon-document'
                "
              ></i>
              {{ item.tenant_type_name }}
            </td>
            <td>{{ item.create_time }}</td>
          </tr>
        </table>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'PersonalFavoritesDetails',
  data() {
    return {
      model: {},
      query: {
        favoritesId: this.$route.params.id,
        pageIndex: 1,
        pageSize: 20,
        keyword: undefined,
        clientType: 1,
      },
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getFavoritesDetails();
      this.getFavoritesRelation();
    },
    // 获取收藏夹详情
    async getFavoritesDetails() {
      const response = await this.$api.favorites.getFavoritesDetails({
        id: this.query.favoritesId,
      });
      this.model = response.data.data;
    },
    // 获取收藏夹内容
    async getFavoritesRelation() {
      const response = await this.$api.favorites.getFavoritesRelation(
        this.query
      );
      this.list = response.data.data;
    },
    // 返回上一层
    goBack() {
      this.$router.go(-1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
